import Splide from "@splidejs/splide";

const init = () => {
    const benefits = document.getElementById("benefits");
    const banners = document.getElementById("banners");
    const products = document.getElementById("products_slider");

    if (benefits) {
        benefitSlider();
    }

    if (banners) {
        bannersSlider();
    }

    if (products) {
        productsSlider();
    }
};

const benefitSlider = () => {
    new Splide("#benefits", {
        arrows: false,
        gap: 20,
        autoWidth: true,
        omitEnd: true,
        focus: 0,
        mediaQuery: "min",
        breakpoints: {
            961: {
                destroy: true,
            },
        },
    }).mount();
};

const bannersSlider = () => {
    new Splide("#banners", {
        arrows: false,
        mediaQuery: "min",
        breakpoints: {
            961: {
                destroy: true,
            },
        },
    }).mount();
};

const productsSlider = () => {
    new Splide("#products_slider", {
        autoWidth: true,
        omitEnd: true,
        focus: 0,
        gap: 10,
        arrows: false,
        mediaQuery: "min",
        breakpoints: {
            1281: {
                destroy: true,
            },
        },
    }).mount();
};

init();
